import fetchExpensesGroupByCategoryReducer from "./getAll";


export const getExpensesReducers = () => ({
    fetchExpensesGroupByCategory: fetchExpensesGroupByCategoryReducer,
});